export const IconButton = ({
  icon,
  small,
  buttonClassAppend,
  ...buttonProps
}) => {
  return (
    <button
      type="button"
      className={`btn btn-icon grid-center${
        buttonClassAppend ? " " + buttonClassAppend : ""
      }${small ? " " + "btn-small" : ""}`}
      {...buttonProps}
    >
      {icon}
    </button>
  );
};
